/**
 * This component renders the news tab for a club page
 * WARNING - Currently using dummy data for news articles
 */
import React from "react";
import NewsOverview from "./NewsOverview";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Loading from "./../core/Loading";

const Component = ({ type, club, sidebar }) => {
  // Define dummy news article
  const { newsId } = useParams();

  const [data, setData] = useState(undefined);

  // Fetch player data from API
  useEffect(() => {
    setData(undefined);

      fetch(`${process.env.REACT_APP_BUIHA_API_URL}/news/${(club === undefined ? "" : "club/" + club + "/")}?count=10`)
      .then((response) => response.json())
      .then((json) => {
        let data = json;

        setData(data);
      })
      .catch((error) => console.error(error));
  }, [newsId]);

  const processEpoch = (epoch) => {
    let then = new Date(epoch * 1000);
    let now = new Date();

    let diff = now - then;

    let days = Math.floor(diff / (1000 * 60 * 60 * 24));
    let hours = Math.floor(diff / (1000 * 60 * 60));
    let mins = Math.floor(diff / (1000 * 60));
    if (days > 365) {
      return `${Math.floor(days / 365)}y`;
    } else if (days > 30) {
      return `${Math.floor(days / 30)}mo`;
    } else if (days > 7) {
      return `${Math.floor(days / 7)}w`;
    } else if (days > 0) {
      return `${days}d`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else {
      return `${mins}min`;
    }
  };

  return data ? (
    <div className="flex flex-row items-start justify-between pt-2 lg:pt-4">
      <div className="flex flex-col w-full xxs:px-4 lg:mx-8 xxs:m-1 px-2">
        <h2 className="leading-tight text-left text-2xl font-semibold mb-2">News</h2>

        {/* placeholder news items */}
        {data.map((article) => {
          return (
            <NewsOverview
              id={article.id}
              title={article.title}
              time={processEpoch(article.date)}
              author={article.author_name}
              img={article.img}
              content={article.text}
              url_override={article.url}
              status={article.status}
            />
          );
        })}
      </div>

      {/* if sidebar is defined, render it */}
      {sidebar ? (
        <div className="lg:block max-lg:hidden">{sidebar}</div>
      ) : (
        <></>
      )}
    </div>
  ) : (
    <Loading />
  );
};
export default Component;
